// extracted by mini-css-extract-plugin
export default {"stateIcon":"TeamAcceptStateCard_stateIcon__8+2Mx","stateIconNeutral":"TeamAcceptStateCard_stateIconNeutral__wplhJ","note":"TeamAcceptStateCard_note__gGs2t"};